<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab finance-budget">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <div class="heig-frame-child">
                <div class="finance-budget-info d-flex justify-content-end align-items-end mt-13 mb-16">
                    <gofix-text-field label="Created By" class="mr-100 width-column-auto" oneline>{{ HeaderItem.created_by_user && HeaderItem.created_by_user.name ? HeaderItem.created_by_user.name : '--' }}</gofix-text-field>
                    <gofix-text-field label="Modified By" class="mr-50 width-column-auto" oneline>{{ HeaderItem.updated_by_user && HeaderItem.updated_by_user.name ? HeaderItem.updated_by_user.name : '--' }}</gofix-text-field>
                    <gofix-button class="mr-4" label="Budget Detail" @click="goToDetail()" outline></gofix-button>
                    <span class="mr-100 budget-status">{{ HeaderItem.status }}</span>
                </div>
                <DetailInfo @reGetHeaderItem="getHeaderItem"/>
                <ListTracking titleTable="Revenue" category="Revenue" ref="revenueList"/>
                <ListTracking titleTable="Expenses" category="Expenses" ref="expensesList"/>
            </div>
        </div>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex';
    const DetailInfo = () => import('./detail-info/info.vue')
    const ListTracking = () => import('./detail-info/list-tracking')

    export default {
        name: 'budget-detail',
        components: {
            DetailInfo,
            ListTracking,
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    },
                ],
            }
        },
        computed: {
            ...mapGetters({
                HeaderItem: 'BudgetAllocationController/headerItem',
            }),
        },
        created() {
            if (!this.$route.params.hasOwnProperty('id') || this.$route.params.id == "0" || isNaN(this.$route.params.id)) {
                return this.$router.push(`/v2/budget`);
            }
            this.getHeaderItem();
        },
        methods: {
            handleShowModalEdit() {
                this.modals.edit.open = true;
            },
            getHeaderItem() {
                this.$store.dispatch("BudgetAllocationController/getHeaderItem", this.$route.params.id)
                    .then(async result => { 
                        if(result.status != 'Approved') {
                            await this.$router.push(`/v2/budget/${this.$route.params.id}`);
                        }
                    })
                    .catch(async err => {
                        await this.$router.push(`/v2/budget`);
                        await this.$alertNotification("Id does not exist", "danger");
                        reject();
                    })
            },
            goToDetail() {
                this.$router.push(`/v2/budget/${this.$route.params.id}`)
            },
        }
    }
</script>
